<amplify-authenticator>
    <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
        <div class="tokenPage">
            <button (click)="signOut()">Sign Out</button>

            <table mat-table [dataSource]="tokens" ttt>
                <ng-container matColumnDef="userExists">
                    <th mat-header-cell *matHeaderCellDef> userExists </th>
                    <td mat-cell *matCellDef="let token">
                        <div >{{token.token.userExists}}</div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let token">
                        <div >{{token.token.name}}</div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="countCurrentMonth">
                    <th mat-header-cell *matHeaderCellDef> Cur Month </th>
                    <td mat-cell *matCellDef="let token"> {{token.countCurrentMonth}} </td>
                </ng-container>
                <ng-container matColumnDef="countPrevMonth">
                    <th mat-header-cell *matHeaderCellDef> prev Month </th>
                    <td mat-cell *matCellDef="let token"> {{token.countPrevMonth}} </td>
                </ng-container>
                <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef> Total </th>
                    <td mat-cell *matCellDef="let token"> {{token.totalCount}} </td>
                </ng-container>
                <ng-container matColumnDef="enable">
                    <th mat-header-cell *matHeaderCellDef> Enable </th>
                    <td mat-cell *matCellDef="let token"> {{token.token.enable}} </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef> Date </th>
                    <td mat-cell *matCellDef="let token"> {{token.token.date}} </td>
                </ng-container>

                <ng-container matColumnDef="month">
                    <th mat-header-cell *matHeaderCellDef> Month1 </th>
                    <td mat-cell *matCellDef="let token"> {{token.token.month}} </td>
                </ng-container>




                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr (click)="gotoTokenDetails(token.token)" class="userExists-{{token.token.userExists}}" mat-row *matRowDef="let token; columns: columnsToDisplay"></tr>

            </table>
            <!-- <div *ngFor="let token of tokens">
            <div>{{ token?.id }}</div>
            <div>{{ token?.name }}</div>
            <div>{{ token?.date }}</div>
            <div>{{ token?.enable }}</div>
        </div> -->

        </div>
    </ng-template>
</amplify-authenticator>